import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-empty-button',
  templateUrl: './empty-button.component.html',
  styleUrls: ['./empty-button.component.scss'],
  standalone: false
})
export class EmptyButtonComponent {
  @Input() size: 'small' | 'default' | 'large' = 'default';
}
